module.exports = {"511129100":"沐溪镇","511129101":"永福镇","511129102":"大楠镇","511129103":"箭板镇","511129104":"舟坝镇","511129105":"黄丹镇","511129106":"利店镇","511129200":"建和乡","511129201":"幸福乡","511129202":"新凡乡","511129203":"富和乡","511129204":"炭库乡","511129205":"底堡乡","511129206":"杨村乡","511129207":"高笋乡","511129208":"茨竹乡","511129209":"海云乡","511129210":"武圣乡","511129211":"凤村乡","511129400":"五马坪监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511129.json
// module id = 2153
// module chunks = 0